import { render, staticRenderFns } from "./Principle.vue?vue&type=template&id=6f4afc98"
import script from "./Principle.vue?vue&type=script&lang=js"
export * from "./Principle.vue?vue&type=script&lang=js"
import style0 from "./Principle.vue?vue&type=style&index=0&id=6f4afc98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports